import React, { Component } from 'react';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import { AdHocSurveyFormContext } from '../../AdHocSurveyContext';

class TabConfigurations extends Component {
    static contextType = AdHocSurveyFormContext;

    updateUrlField(field, value) {
        const selectedAdHocSurvey = this.context.selectedAdHocSurvey;
        selectedAdHocSurvey[field] = value;
        this.context.updateSelectedAdHocSurvey(selectedAdHocSurvey);
    }

    renderUrlField(label, field) {
        const selectedAdHocSurvey = this.context.selectedAdHocSurvey;
        return (
            <div className="form-row" style={{ marginBottom: '5px', gap: '10px' }}>
                <div className="form-row-left" style={{ flex: '0 0 10%', justifyContent: 'flex-end', lineHeight: '40px', maxWidth: '10%' }}>{label}</div>
                <div className="form-row-right" style={{ flex: '1 1 0', maxWidth: '90%', justifyContent: 'flex-start' }}>
                    <div style={{ width: '100%' }}>
                        <EcoInput
                            id={field}
                            name={field}
                            style={{ width: '100%' }}
                            disabled={!this.props.canChangeData}
                            value={selectedAdHocSurvey[field] || ''}
                            onChange={event => this.updateUrlField(field, event.target.value)}
                            placeholder="https://example.com/return?uid={{system.userid}}"
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="content-box">
                <Card>
                    <h3>Return URLs</h3>
                    {this.renderUrlField('Complete', 'completeReturnUrl')}
                    {this.renderUrlField('Screen Out', 'screenOutReturnUrl')}
                    {this.renderUrlField('Quota Full', 'quotaFullReturnUrl')}
                </Card>
            </div>
        );
    }
}

export default TabConfigurations;
